export default "__VITE_ASSET__d3f1e564__"